import React, { useContext } from "react";

// global state
import { StateContext } from "../../AppStateContext";

// Styling
import "./AddNewClassModals.css";

// Material uI imports
import Tooltip from "@material-ui/core/Tooltip";
import HelpIcon from "@material-ui/icons/Help";

// Styling
import "./AddNewClassModals.css";

const AddNewPropertyModalHeader = () => {
  // global state
  const state = useContext(StateContext);
  return (
    <div className="__addPropertyHeaderModal">
      <h2
        className={
          state.theme === "dark"
            ? "__addPropertyHeaderModalDark __addPropertyHeaderModal"
            : "__addPropertyHeaderModalLight __addPropertyHeaderModal"
        }
      >
        New Property
      </h2>
      <Tooltip
        title="Properties define what kind of data values you will add to an object in Weaviate. In the schema, you define at least the name of the property and its dataType. A new property becomes immutable after it is added to the class and the class is added to the schema."
        placement="right-start"
      >
        <HelpIcon
          style={{
            color: state.theme === "dark" ? "#848484" : "#5e5e5e",
            cursor: "pointer",
            marginTop: "5px",
          }}
        />
      </Tooltip>
    </div>
  );
};

export default AddNewPropertyModalHeader;
